import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import Menu from "./menu"

import logo from "../images/FC_Reversed.svg"

const Header = ({ siteTitle }) => (
  <div className="bg-gray-700">
    <header className="flex mx-auto p-4 flex-col lg:pl-10 lg:pr-10 lg:justify-between lg:flex-row">
      <Link to="/">
        <img src={logo} className="w-16" alt="{siteTitle}" />
      </Link>{" "}
      <Menu />
    </header>{" "}
  </div>
)

Header.propTypes = {
  siteTitle: PropTypes.string
}

Header.defaultProps = {
  siteTitle: ``
}

export default Header
